'use client';

import { Slot } from '@magicschool/spellbook/components/Slot';
import { cn } from '@magicschool/spellbook/lib/utils';

/**
 * Optional unit label rendered between the input value and the stepper buttons.
 * Use this slot to add contextual units like 'pts', 'kg', '%', etc.
 *
 * @example
 * <NumberInput min={0} max={100}>
 *   <NumberInput.Unit>pts</NumberInput.Unit>
 * </NumberInput>
 */
export type NumberInputUnitSlotProps = React.HTMLAttributes<HTMLSpanElement> & {
  /** @internal Injected by NumberInput — do not pass manually. */
  size?: 'md' | 'lg';
};

export const NumberInputUnitSlot = Slot<NumberInputUnitSlotProps>({
  displayName: 'NumberInput.Unit',
  renderDefault: ({ children, className, size = 'md', ...props }) => (
    <span
      data-spellbook-name="number-input-unit"
      className={cn('flex items-center shrink-0 text-default-text-soft', size === 'md' ? 'px-1.5 text-xs' : 'px-2 text-sm', className)}
      {...props}
    >
      {children}
    </span>
  ),
});
